// SisterAI — calls server-side /api/ask endpoint (no API key in browser)
// Server handles DeepSeek calls with DEEPSEEK_API_KEY

import { LanguageCode, TriageLevel } from '../types';

export const extractTriageLevel = (text: string): TriageLevel => {
  if (text.includes('{{TRIAGE:EMERGENCY}}')) return 'emergency';
  if (text.includes('{{TRIAGE:URGENT}}'))    return 'urgent';
  if (text.includes('{{TRIAGE:MONITOR}}'))   return 'monitor';
  if (text.includes('{{TRIAGE:SELFCARE}}'))  return 'selfcare';
  return null;
};

export const stripTriageMarker = (text: string): string =>
  text
    .replace(/\{\{TRIAGE:EMERGENCY\}\}/g, '')
    .replace(/\{\{TRIAGE:URGENT\}\}/g, '')
    .replace(/\{\{TRIAGE:MONITOR\}\}/g, '')
    .replace(/\{\{TRIAGE:SELFCARE\}\}/g, '')
    .trim();

export const getHealthResponse = async (
  question: string,
  language: LanguageCode,
  history: { role: 'user' | 'model'; content: string }[] = []
): Promise<{ response: string; triageLevel: TriageLevel }> => {
  const res = await fetch('/api/ask', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ question, language, history }),
  });

  if (!res.ok) throw new Error('API request failed');
  const data = await res.json();

  return {
    response: `### \u{1FA78} Clinical Assessment\n${data.response}\n\n---\n*SisterAI is a health information tool only. It does not replace a doctor, nurse, or traditional healer. For emergencies: **112** (Emergency) | **10177** (Ambulance) | **SADAG** 0800 567 567 (Mental Health)*`,
    triageLevel: data.triageLevel,
  };
};

// Stub for voice hook compatibility
export const streamSpeech = async function* (
  _text: string,
  _language: LanguageCode
): AsyncGenerator<string> {
  // Voice output disabled. Use browser speechSynthesis.
};
